module.exports = __webpack_public_path__ + "static/media/BookBrand.7835ac38.svg";